import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { listMutations } from '@/modules/sklad/ndPohyb/store/types';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		SkladOzn: [],
		VyrobekndOzn: [],
		VstupProvId: [],
		NdpohybList: [],
		ZakazkaDruh: [],
		ZbozidruhOzn: [],
	},
	filter: {
		DodListNr: null as string | null,
		DodavatelId: null as number | null,
		DokladNr: null as number | null,
		DokladPfx: null as string | null,
		MarketKod: null as string | null,
		NdNrDo: null as string | null,
		NdNrOd: null as string | null,
		NdpohybList: null as number[] | null,
		ObjednNr: null as number | null,
		ObjednPfx: null as string | null,
		PracovnikId: null as number | null,
		ProvozovnaId: null as number | null,
		RabatSk: null as string | null,
		RabatSkText: null as string | null,
		SkladOzn: null as number | null,
		SkladmistoDo: null as string | null,
		SkladmistoOd: null as string | null,
		StrednaklOzn: null as number | null,
		Terminal: null as string | null,
		Text: null as string | null,
		VstupPracId: null as number | null,
		VstupProvId: null as number | null,
		VyrobekndOzn: null as string | null,
		ZakazkaDruh: null as string | null,
		ZakazkaId: null as number | null,
		ZakazkaNr: null as number | null,
		ZakaznikId: null as number | null,
		ZalozenoOd: null as Date | null,
		ZalozenoDo: null as Date | null,
		ZbozidruhOzn: null as string | null,
		VstupPracIdText: null as string | null,
		VstupPracOsobniCis: null as string | null,
		PracovnikIdText: null as string | null,
		PracovnikOsobniCis: null as string | null,
		DodavatelIdText: null as string | null,
		ZbozidruhOznText: null as string | null,
		StrednaklOznText: null as string | null,
	},
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[listMutations.ND_POHYB_DODAVATEL_FILTER_SELECT_MAPPER](state, { data }) {
			state.filter.DodavatelId = data.value;
			state.filter.DodavatelIdText = data.text;
		},
		[listMutations.ND_POHYB_ZBOZI_FILTER_SELECT_MAPPER](state, { data }) {
			state.filter.ZbozidruhOzn = data.value;
			state.filter.ZbozidruhOznText = data.text;
		},
		[listMutations.ND_POHYB_NAKLADOVE_STREDISKO_FILTER_SELECT_MAPPER](state, { data }) {
			state.filter.StrednaklOzn = data.value;
			state.filter.StrednaklOznText = data.text;
		},
		[listMutations.ND_POHYB_RABAT_SK_FILTER_SELECT_MAPPER](state, { data }) {
			state.filter.RabatSk = data.value;
			state.filter.RabatSkText = data.text;
		},
		[listMutations.ND_POHYB_PRACOVNIK_FILTER_SELECT_MAPPER](state, { data }) {
			state.filter.PracovnikId = data.value;
			state.filter.PracovnikIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.filter.PracovnikOsobniCis = data.osobniCis;
		},
		[listMutations.ND_POHYB_ZADAVATEL_FILTER_SELECT_MAPPER](state, { data }) {
			state.filter.VstupPracId = data.value;
			state.filter.VstupPracIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.filter.VstupPracOsobniCis = data.osobniCis;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
